export default __webpack_public_path__ + "static/media/about-main-md.5709f634.jpg";